{
  "title": "爆房",
  "subtitle": "選一間房，開獎炸掉 {{count}} 間",
  "tables": "桌型",
  "stageNine": "九燈雪屋村",
  "stageSix": "六燈遠征地",
  "tier": {
    "classic_9": "經典九房",
    "high_risk_6": "高風險六房"
  },
  "lobby": "大廳",
  "backLobby": "回大廳",
  "connecting": "連線中…",
  "connected": "已連線",
  "reconnecting": "重連中…",
  "authFailed": "登入失敗",
  "retryLogin": "重試連線",
  "unauthorized": "請從大廳進入",
  "balance": "餘額 {{amount}}",
  "room": "{{id}}",
  "selectedRoom": "房間 {{id}}",
  "players": "{{n}} 人",
  "presence": "桌內 {{seated}} · 旁觀 {{watching}} · 總注 {{pot}}",
  "selectRoom": "請先選擇房間",
  "bet": "下注金額",
  "half": "1/2",
  "max": "全下",
  "quickChips": "快速籌碼",
  "close": "關閉",
  "placed": "已下 {{amount}}",
  "submittingBet": "下注送出中…",
  "switchingRoom": "更換房間中…",
  "connectionUnavailable": "連線尚未恢復，下注功能暫停",
  "requestFailed": "操作未完成，請確認連線後再試",
  "balanceRefreshFailed": "本局已完成，餘額暫時無法更新",
  "settlementReconciliation": "上一筆派彩仍待確認，客服完成核對前已暫停下注。",
  "settlementReconciliationRound": "第 {{roundId}} 局派彩尚未入帳，需由客服人工處理。新的下注已暫停，聯絡客服時請提供此局號。",
  "settlementNeedsReview": "派彩待核對",
  "retryBalance": "重新整理餘額",
  "refreshingBalance": "正在更新餘額…",
  "switchRoom": "點其他房可更換",
  "bettingLeft": "{{sec}}s",
  "bettingLive": "下注中，剩餘 {{sec}} 秒",
  "roomAvailable": "可選擇",
  "roomSelected": "已選擇",
  "roomSafe": "安全房間",
  "roomExploded": "已爆炸",
  "roomOdds": "賠率 {{odds}} 倍",
  "roomOddsPending": "賠率載入中",
  "youWin": "獲勝 +{{payout}}",
  "youLose": "未中 −{{amount}}",
  "rules": "遊戲規則",
  "rulesTitle": "爆房 (Blast Rooms) 遊戲說明",
  "rulesBody": "進入雪屋村落並選擇一間避難房間下注。倒數結束後，系統將隨機引爆指定數量的房間。未被引爆之安全房間內的玩家將依該房賠率均分派彩。",
  "phase": {
    "waiting": "準備中",
    "betting": "下注中",
    "locked": "開獎中",
    "revealing": "開獎中",
    "settled": "本局結束"
  }
}
